import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shield, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { apiErr } from "@/lib/api";
import logo from "@/assets/pk-logo.png";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await login(email, password); nav("/admin"); }
    catch (e2) { setErr(apiErr(e2, "Login failed")); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "radial-gradient(1200px 600px at 20% -10%, rgba(124,58,237,0.25), transparent), #0C0A1E" }}>
      <form onSubmit={submit} className="w-full max-w-sm space-y-5 bg-[#15122E] border border-white/10 rounded-2xl p-8 text-slate-200" data-testid="admin-login-form">
        <div className="flex items-center gap-3">
          <img src={logo} alt="Parth Kalyani" className="h-12 w-auto" />
          <div className="text-[10px] font-bold tracking-widest" style={{ color: "#06B6D4" }}>PLATFORM CONSOLE</div>
        </div>
        <div><h2 className="text-xl font-bold font-display">Admin sign in</h2><p className="text-sm text-slate-400 mt-1">Restricted access</p></div>
        <div className="space-y-2"><Label>Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-white/5 border-white/10" data-testid="admin-email" required /></div>
        <div className="space-y-2"><Label>Password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-white/5 border-white/10" data-testid="admin-password" required /></div>
        {err && <div className="text-sm text-red-400" data-testid="admin-login-error">{err}</div>}
        <Button type="submit" className="w-full" style={{ background: "#7C3AED" }} disabled={loading} data-testid="admin-login-submit">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}</Button>
        <a href="/login" className="block text-center text-xs text-slate-500 hover:text-slate-300">← Back to client login</a>
      </form>
    </div>
  );
}
